module.exports = __webpack_public_path__ + "img/電気回路_4_9_2.fadb7cfb.png";